import React, { ErrorInfo, ReactNode } from 'react';
import { ConfigurationContext } from '../../providers/ConfigurationProvider';
import { logError } from '../../features/common/Common.utils';
export default class ExceptionHandler extends React.Component<Props, State> {
  static contextType = ConfigurationContext;

  constructor(props: any) {
    super(props);
    this.state = { error: undefined, errorInfo: undefined };
  }

  public static getDerivedStateFromError(error: Error): State {
    return { error: error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error: error, errorInfo: errorInfo });

    logError({
      apiURL: this.context.API_URL,
      errorMessage: error.message,
      errorStack: errorInfo.componentStack,
    });
  }

  public render() {
    if (this.state.error) {
      return <div>Error!</div>;
    }

    return this.props.children;
  }
}

interface Props {
  children: ReactNode;
}

interface State {
  error?: Error;
  errorInfo?: ErrorInfo;
}
